// Einladung annehmen (ohne Anmeldung): Der Link aus Einstellungen › Nutzer führt auf /login?einladung=<Token>. Hier wählt die
// eingeladene Person Namen und Passwort; danach meldet sie sich normal an. Eingebunden von pages/Login.tsx.
import { useEffect, useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { ApiFehler } from "../api";
import { nutzerVerwaltungApi } from "../api/nutzerVerwaltung";
import logo from "../assets/logo.png";
import { fehlerInfo } from "../components/Fehler";
import { T8C } from "./texte";
import "../pages/einstellungen/nutzer.css";

const T = T8C.einladungAnnehmen;

export function EinladungAnnehmen({ token }: { token: string }) {
  const navigate = useNavigate();
  const [info, setInfo] = useState<{ email: string; rolle: string; rolle_name?: string } | null>(null);
  const [ungueltig, setUngueltig] = useState<string | null>(null);
  const [vorname, setVorname] = useState("");
  const [nachname, setNachname] = useState("");
  const [passwort, setPasswort] = useState("");
  const [passwort2, setPasswort2] = useState("");
  const [fehler, setFehler] = useState<string | null>(null);
  const [laeuft, setLaeuft] = useState(false);
  const [fertig, setFertig] = useState(false);

  useEffect(() => {
    let aktiv = true;
    nutzerVerwaltungApi
      .einladungAnsehen(token)
      .then((r) => aktiv && setInfo(r))
      .catch((e) => aktiv && setUngueltig(e instanceof ApiFehler && e.code === "einladung_ungueltig" ? T.ungueltig : fehlerInfo(e).text));
    return () => {
      aktiv = false;
    };
  }, [token]);

  const absenden = async (e: FormEvent) => {
    e.preventDefault();
    if (passwort !== passwort2) {
      setFehler(T.nichtGleich);
      return;
    }
    setLaeuft(true);
    setFehler(null);
    try {
      await nutzerVerwaltungApi.einladungAnnehmen({ token, vorname: vorname.trim(), nachname: nachname.trim(), passwort });
      setFertig(true);
    } catch (err) {
      setFehler(fehlerInfo(err).text);
    } finally {
      setLaeuft(false);
    }
  };

  return (
    <div className="anmeldung">
      <form className="anmeldung__karte" onSubmit={(e) => void absenden(e)}>
        <div className="anmeldung__marke">
          <img className="anmeldung__logo" src={logo} alt="B2B Förderzentrum" width={210} height={47} />
          <span className="anmeldung__untertitel">CRM</span>
        </div>
        {fertig ? (
          <>
            <h1>{T.fertigTitel}</h1>
            <p className="seite__text">{T.fertigText}</p>
            <button type="button" className="knopf knopf--primaer knopf--breit" onClick={() => navigate("/login", { replace: true })}>
              {T.zumLogin}
            </button>
          </>
        ) : ungueltig ? (
          <>
            <h1>{T.titel}</h1>
            <div className="hinweis hinweis--fehler" role="alert">
              {ungueltig}
            </div>
            <button type="button" className="knopf knopf--breit" onClick={() => navigate("/login", { replace: true })}>
              {T.zumLogin}
            </button>
          </>
        ) : !info ? (
          <p className="seite__text">{T.laden}</p>
        ) : (
          <>
            <h1>{T.titel}</h1>
            <p className="seite__text">{T.text(info.email, info.rolle_name ?? info.rolle)}</p>
            {fehler ? (
              <div className="hinweis hinweis--fehler" role="alert">
                {fehler}
              </div>
            ) : null}
            <div className="formular__zwei">
              <label className="feld">
                <span className="feld__label">{T.vorname}</span>
                <input className="eingabe" autoComplete="given-name" value={vorname} onChange={(e) => setVorname(e.target.value)} required autoFocus />
              </label>
              <label className="feld">
                <span className="feld__label">{T.nachname}</span>
                <input className="eingabe" autoComplete="family-name" value={nachname} onChange={(e) => setNachname(e.target.value)} required />
              </label>
            </div>
            <label className="feld">
              <span className="feld__label">{T.passwort}</span>
              <input className="eingabe" type="password" autoComplete="new-password" minLength={12} value={passwort} onChange={(e) => setPasswort(e.target.value)} required />
              <span className="nv-hilfe">{T.passwortHilfe}</span>
            </label>
            <label className="feld">
              <span className="feld__label">{T.passwort2}</span>
              <input className="eingabe" type="password" autoComplete="new-password" minLength={12} value={passwort2} onChange={(e) => setPasswort2(e.target.value)} required />
            </label>
            <button className="knopf knopf--primaer knopf--breit" type="submit" disabled={laeuft}>
              {laeuft ? T.laeuft : T.knopf}
            </button>
          </>
        )}
      </form>
    </div>
  );
}
